<template>
  <div class="hero-card">
    <h1>Black Basta Chat Logs</h1>
    <p class="description">
      This is a collection of chat logs from the Black Basta ransomware group, one of the most prolific ransomware groups known to date. Explore leaked internal communications of the group, revealing operations, tactics, and discussions.
    </p>
    <p class="warning">
      Note: These chat logs are unfiltered and some things may have been lost in translation. These messages are UNFILTERED messages from the Black Basta ransomware group. Use at your own risk.
    </p>
  </div>
</template>

<script>
export default {
  name: 'HeroCard'
}
</script>

<style scoped>
.hero-card {
  padding: 2rem;
  margin-bottom: 2rem;
  text-align: left;
  max-width: 800px;
}

h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: var(--text-primary);
}

.description {
  font-size: 1.1rem;
  color: var(--text-secondary);
  margin-bottom: 1rem;
  line-height: 1.6;
}

.warning {
  font-size: 0.9rem;
  color: var(--text-secondary);
  font-style: italic;
  border-top: 1px solid var(--border);
  padding-top: 1rem;
  margin-top: 1rem;
}
</style> 